import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dd10c938")

_pushScopeId("data-v-dd10c938")
const _hoisted_1 = { class: "banner-view-root" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_slide = _resolveComponent("slide")
  const _component_carousel = _resolveComponent("carousel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_carousel, {
      autoplay: 10000,
      "items-to-show": 1,
      wrapAround: true,
      class: "slide-contents",
      modelValue: _ctx.selectedIndex,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedIndex = $event))
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, _index) => {
          return (_openBlock(), _createBlock(_component_slide, {
            key: `slide-${_index}`,
            class: "slide"
          }, {
            default: _withId(() => [
              _createVNode("img", {
                src: slide,
                onClick: ($event: any) => (_ctx.imageClicked(_index))
              }, null, 8, ["src", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("ul", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (i, index) => {
        return (_openBlock(), _createBlock("li", {
          key: index,
          class: { active: _ctx.selectedIndex === index },
          onClick: ($event: any) => (_ctx.selectedIndex = index)
        }, null, 10, ["onClick"]))
      }), 128))
    ])
  ]))
})